import { inject, Injectable } from '@angular/core'
import { config } from '../../config/appConfig'
import { HttpService } from './http.service'
import { Observable } from 'rxjs'
import { IReportInfo, IReportInfoResponse, IResponse } from '../models/admin';

export enum ReportEndPoints {
    gstreport = '/reports/gstreport'
}

@Injectable({
    providedIn: 'root',
})
export class ReportService {
    httpService: HttpService = new HttpService(config.userServiceURL);

    getGSTOrders(): Observable<IReportInfoResponse> {
        return this.httpService.get(ReportEndPoints.gstreport);
    }
}